import React from "react";
import { GoogleMap, Marker, Circle, useJsApiLoader } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import { GOOGLE_MAPS_API_KEY } from "../config/google";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const mapOptions = {
  disableDefaultUI: true,
  zoomControl: true,
  streetViewControl: false,
  fullscreenControl: false,
};

const circleOptions = {
  strokeColor: "#ADD8E6",
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: "#BAC9FF",
  fillOpacity: 0.35,
};

function MapContent({ center, businesses, onMarkerClick }) {
  const centerIcon = {
    path: window.google.maps.SymbolPath.CIRCLE,
    scale: 6,
    fillColor: '#5072ef',
    fillOpacity: 1,
    strokeWeight: 0,
  };
  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12} options={mapOptions}>
      <Circle center={center} radius={24140.2} options={circleOptions} />
      <Marker position={center} icon={centerIcon} />
      {Array.isArray(businesses) &&
        businesses.map((business, index) => {
          if (typeof business.latitude !== 'number' || typeof business.longitude !== 'number') {
            return null;
          }
          return (
            <Marker
              key={`${business.registration_id || business.id || index}`}
              position={{ lat: business.latitude, lng: business.longitude }}
              title={business.business_name || ''}
              onClick={() => {
                if (typeof onMarkerClick === 'function') {
                  onMarkerClick(business);
                }
              }}
            />
          );
        })}
    </GoogleMap>
  );
}

export default function DashboardLocationMap({ center, businesses, onMarkerClick }) {
  const { t } = useTranslation(['displayMain']);
  const { isLoaded, loadError } = useJsApiLoader({
    id: "dashboard-location-map",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  if (loadError) {
    return <div className="map-placeholder">{t('displayMain:map.loadError')}</div>;
  }

  if (!isLoaded) {
    return <div className="map-placeholder">{t('displayMain:map.loading')}</div>;
  }

  return <MapContent center={center} businesses={businesses} onMarkerClick={onMarkerClick} />;
}
